/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminUser
 */
export interface InputAdminUser {
    /**
     * 
     * @type {number}
     * @memberof InputAdminUser
     */
    brigadeId?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUser
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUser
     */
    deltaLogin?: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUser
     */
    division?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUser
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUser
     */
    osg?: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUser
     */
    otg?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InputAdminUser
     */
    otgIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof InputAdminUser
     */
    role: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminUser
     */
    zone?: number;
}

/**
 * Check if a given object implements the InputAdminUser interface.
 */
export function instanceOfInputAdminUser(value: object): boolean {
    if (!('email' in value)) return false;
    if (!('name' in value)) return false;
    if (!('role' in value)) return false;
    return true;
}

export function InputAdminUserFromJSON(json: any): InputAdminUser {
    return InputAdminUserFromJSONTyped(json, false);
}

export function InputAdminUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminUser {
    if (json == null) {
        return json;
    }
    return {
        
        'brigadeId': json['brigadeId'] == null ? undefined : json['brigadeId'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'deltaLogin': json['deltaLogin'] == null ? undefined : json['deltaLogin'],
        'division': json['division'] == null ? undefined : json['division'],
        'email': json['email'],
        'name': json['name'],
        'osg': json['osg'] == null ? undefined : json['osg'],
        'otg': json['otg'] == null ? undefined : json['otg'],
        'otgIds': json['otgIds'] == null ? undefined : json['otgIds'],
        'role': json['role'],
        'zone': json['zone'] == null ? undefined : json['zone'],
    };
}

export function InputAdminUserToJSON(value?: InputAdminUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'brigadeId': value['brigadeId'],
        'comment': value['comment'],
        'deltaLogin': value['deltaLogin'],
        'division': value['division'],
        'email': value['email'],
        'name': value['name'],
        'osg': value['osg'],
        'otg': value['otg'],
        'otgIds': value['otgIds'],
        'role': value['role'],
        'zone': value['zone'],
    };
}

